import clsx from 'clsx';
import CookieSettings from '../CookieSettings/CookieSettings';
import Logo from '../Logo/Logo';
import { LogoVariant } from '../Logo/consts';
import styles from './RegioFooter.module.scss';
import { REGIO_FOOTER_LINKS_DEFAULT } from './consts';
import type { RegioFooterProps } from './interfaces';

const RegioFooter = ({
  baseLinks = REGIO_FOOTER_LINKS_DEFAULT,
  copyright = 'enercity AG',
  copyrightLink = 'https://www.enercity.de',
}: RegioFooterProps) => {
  const currentDate = new Date();
  return (
    <footer>
      <div className={styles.base}>
        <a
          className={clsx('cta_', styles.logo)}
          id="footer-logo-to-start"
          title="Zur Startseite"
          href="/"
        >
          <Logo variant={LogoVariant.White} />
        </a>
        <div className={styles.baseLinks}>
          {baseLinks.map(({ label, url }) => (
            <a key={url} href={url} className={clsx('cta_', styles.baseLink)}>
              {label}
            </a>
          ))}
          <CookieSettings className={styles.baseLink} />
        </div>
        <a href={copyrightLink} className={styles.baseLink}>
          © {currentDate.getFullYear()} {copyright}
        </a>
      </div>
    </footer>
  );
};

export default RegioFooter;
